"use client";

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export interface FAQItem {
  id: string | number;
  question: string;
  answer: any;
}

interface FAQSectionProps {
  faqs: FAQItem[];
  title?: string;
  subtitle?: string;
  path?: string;
}
import { CTAButtons } from "@/components/ui/action-buttons";
import { useTranslation } from "../language/hooks/useTranslation";

export function FAQSection({
  faqs,
  title = "Frequently Asked Questions",
  subtitle,
  path = "/register",
}: FAQSectionProps) {
  const { t } = useTranslation();
  console.log(faqs);
  return (
    <section className="bg-transparent">
      <div className="px-0 mx-auto lg:max-w-4xl xl:max-w-6xl 3xl:max-w-[1432px]">
        <div className="text-center mb-14">
          <h1 className="mb-4 text-brand-black text-4xl lg:text-6xl xl:text-7xl 3xl:text-8xl font-bold" >{title}</h1>
          {subtitle && (
            <p className="mb-3 text-base text-muted-foreground text-brand-card/80 3xl:text-2xl">{subtitle}</p>
          )}
          <CTAButtons
            primary={{
              text: t("dashboard.compare.getStarted"),
              url: "/register",
            }}
            secondary={{
              text: t("dashboard.compare.learnMore"),
              url: `${path}`,
              className: "second-button border-brand-grey text-brand-card",
            }}
          />
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={faq.id.toString()}
              className="bg-white/5 global-border-radius border border-brand-grey transition-all duration-200 overflow-hidden
                         data-[state=open]:border-brand-grey
                         data-[state=open]:border-brand-grey
                        data-[state=open]:shadow-[0_8px_30px_rgba(255,115,0,0.12)]
                         data-[state=open]:shadow-orange-500/5
                         "
            >
              <AccordionTrigger className="px-6 py-5 text-base font-semibold text-left text-brand-card sm:text-lg hover:no-underline 3xl:text-[2rem]">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-6 text-base leading-relaxed text-brand-card 3xl:text-xl">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
